var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.333008,
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#161E40"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9092,
    y: 0.333008,
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#F4B644"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 11.2421,
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#161E40"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9092,
    y: 11.2421,
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#161E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.a981c372c248d45ec585032640f730e3.svg";
export { ForwardRef as ReactComponent };